module.exports = __webpack_public_path__ + "static/media/favicon.e9ca2ccf.svg";